<template>
  <div class="hzc-coke">
    <div class="content container">
      <div class="banner-left" @click="changeIndustrial">
        <p class="banner-title">{{ chainTitle }}</p>
        <div class="data1">{{ data1['druidParamName'] }} <p style="color: #2AD3DA;">{{ data1['price'] }}</p></div>
        <div class="data2">{{ `${data2['druidParamName']}:` }} <p style="color: #2AD3DA">{{ data2['price'] }}</p>
        </div>
        <div class="data3">{{ `${data3['druidParamName']}:` }} <p style="color: #2AD3DA">{{ data3['price'] }}</p>
        </div>
        <div class="data4">{{ `${data4['druidParamName']}:` }} <p style="color: #2AD3DA">{{ data4['price'] }}</p>
        </div>
      </div>
      <div class="banner-right">
        <div class="title">
          <div class="title-write"
               :class="{'title-write-red' : true}">行业动态
          </div>
          <span class="title-more fr" @click="toTwoPage('/petroleum/twoPage/industry')">更多 ></span>
        </div>
        <div class="banner-right-content">
          <ul>
            <li v-for="(item, index) in industryList" :key="index">
              <p v-if="item.newsType===1" @click="goDetail('/petroleum/industry', item.id, 2)">{{ item.titleName }}</p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification">
      <ul class="clearfix">
        <li>
          <img style="margin-bottom: -6px;" src="../../assets/ironstone/jiage.png" alt="">
          <p style="position: absolute;top: 20px;left: 20px;width: 48px;height: 33px;font-size: 24px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #222222;line-height: 33px;">
            价格</p>
          <span style="position: absolute;right: 10px;top: 27px;cursor: pointer"
                @click="toTwoPage('/petroleum/twoPage/price')"> >></span>
          <span class="classification-tabs-two" @mouseover="priceFlag = 'issue_petroleum_database_present_price'"
                style="width:186px;"
                @click="toTwoPage('/petroleum/twoPage/price', 'issue_petroleum_database_present_price')"
                :class="{'priceFlag':priceFlag === 'issue_petroleum_database_present_price'}">现货价格</span>
          <span class="classification-tabs-two" @mouseover="priceFlag = 'issue_petroleum_database_futures_price'"
                style="width:186px;"
                @click="toTwoPage('/petroleum/twoPage/price', 'issue_petroleum_database_futures_price')"
                :class="{'priceFlag':priceFlag === 'issue_petroleum_database_futures_price'}">期货价格</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="priceFlag === 'issue_petroleum_database_present_price'">
            <div class="classification-content-div"
                 v-for="(item, index) in priceOneList" :key="index"
                 @click="goDetail('/petroleum/price', item.completeOriginalDate, 'issue_petroleum_database_present_price')">
              <i></i>
              <p>{{ item.date + '原油现货价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="priceFlag === 'issue_petroleum_database_futures_price'">
            <div class="classification-content-div"
                 v-for="(item, index) in priceTwoList" :key="index"
                 @click="goDetail('/petroleum/price', item.completeOriginalDate, 'issue_petroleum_database_futures_price')">
              <i></i>
              <p>{{ item.date + '原油期货价格' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <img style="margin-bottom: -6px;" src="../../assets/images/kucun.png" alt="">
          <p style="position: absolute;top: 20px;left: 20px;height: 33px;font-size: 24px;font-weight: 500;color: #fff;line-height: 33px;">
            原油及成品油库存</p>
          <span style="color:#fff;position: absolute;right: 10px;top: 27px;cursor: pointer"
                @click="toTwoPage('/petroleum/twoPage/stock')"> >></span>
          <span class="classification-tabs-three" @mouseover="stockFlag = 'issue_petroleum_primary_stock'"
                @click="toTwoPage('/petroleum/twoPage/stock', 'issue_petroleum_primary_stock')"
                :class="{'stockFlag':stockFlag === 'issue_petroleum_primary_stock'}">OECD原油库存</span>
          <span class="classification-tabs-three" @mouseover="stockFlag = 'issue_petroleum_api_stock'"
                @click="toTwoPage('/petroleum/twoPage/stock', 'issue_petroleum_api_stock')"
                :class="{'stockFlag':stockFlag === 'issue_petroleum_api_stock'}">API库存</span>
          <span class="classification-tabs-three" @mouseover="stockFlag = 'issue_petroleum_eia_stock'"
                @click="toTwoPage('/petroleum/twoPage/stock', 'issue_petroleum_eia_stock')"
                :class="{'stockFlag':stockFlag === 'issue_petroleum_eia_stock'}">EIA库存</span>
          <span class="classification-tabs-three" @mouseover="stockFlag = 'issue_petroleum_singapore_stock'"
                @click="toTwoPage('/petroleum/twoPage/stock', 'issue_petroleum_singapore_stock')"
                :class="{'stockFlag':stockFlag === 'issue_petroleum_singapore_stock'}">新加坡库存</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="stockFlag === 'issue_petroleum_primary_stock'">
            <div class="classification-content-div"
                 v-for="(item, index) in stockOneList" :key="index"
                 @click="goDetail('/petroleum/stock', item.completeOriginalDate, 'issue_petroleum_primary_stock')">
              <i></i>
              <p>{{ item.date + 'OECD原油库存' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="stockFlag === 'issue_petroleum_api_stock'">
            <div class="classification-content-div"
                 v-for="(item, index) in stockTwoList" :key="index"
                 @click="goDetail('/petroleum/stock', item.completeOriginalDate, 'issue_petroleum_api_stock')">
              <i></i>
              <p>{{ item.date + 'API库存' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="stockFlag === 'issue_petroleum_eia_stock'">
            <div class="classification-content-div"
                 v-for="(item, index) in stockThreeList" :key="index"
                 @click="goDetail('/petroleum/stock', item.completeOriginalDate, 'issue_petroleum_eia_stock')">
              <i></i>
              <p>{{ item.date + 'EIA库存' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="stockFlag === 'issue_petroleum_singapore_stock'">
            <div class="classification-content-div"
                 v-for="(item, index) in stockFourList" :key="index"
                 @click="goDetail('/petroleum/stock', item.completeOriginalDate, 'issue_petroleum_singapore_stock')">
              <i></i>
              <p>{{ item.date + '新加坡库存' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none">
            <em></em>
            <p>研究报告</p>
            <span class="fr" @click="toTwoPage('/petroleum/twoPage/report')"> >></span>
            <img src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;" alt="">
            <div class="report-tabs">
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 1}"
                   @click="reportToPage('/petroleum/twoPage/report', 1)" @mouseover="changeReportFlag(1)">日报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 2}"
                   @click="reportToPage('/petroleum/twoPage/report', 2)" @mouseover="changeReportFlag(2)">周报
              </div>
              <div class="tabs-i" :class="{'tabs-i-hover':reportFlag === 3}"
                   @click="reportToPage('/petroleum/twoPage/report', 3)" @mouseover="changeReportFlag(3)">月报
              </div>
            </div>
          </div>
          <div class="classification-content research">
            <img style="width: 360px" src="../../assets/home/yanjiubaogao.png" alt="">
            <div v-if="reportFlag === 1">
              <div class="classification-content-div" v-for="(item, index) in reportList" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 2">
              <div class="classification-content-div" v-for="(item, index) in reportListWeek" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 3">
              <div class="classification-content-div" v-for="(item, index) in reportListMonth" :key="index">
                <i></i>
                <p style="width: 200px;" @click="downloadReport(item)">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'原油产量'" :flag="false" :unit="false"
                                :params="{title:'原油产量',typeList:['预测值', '实际值']}"
                                :url="'/petroleum/twoPage/yield'"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="yieldFlag = 'issue_petroleum_yield_forecast'"
                style="width:186px;font-size: 14px"
                @click="toTwoPage('/petroleum/twoPage/yield', 'issue_petroleum_yield_forecast')"
                :class="{'stockFlag':yieldFlag === 'issue_petroleum_yield_forecast'}">预测值</span>
          <span class="classification-tabs-three" @mouseover="yieldFlag = 'issue_petroleum_yield'"
                style="width:186px;font-size: 14px"
                @click="toTwoPage('/petroleum/twoPage/yield', 'issue_petroleum_yield')"
                :class="{'stockFlag':yieldFlag === 'issue_petroleum_yield'}">实际值</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="yieldFlag === 'issue_petroleum_yield_forecast'">
            <div class="classification-content-div"
                 v-for="(item, index) in yieldOneList" :key="index"
                 @click="goDetail('/petroleum/yield', item.completeOriginalDate, 'issue_petroleum_yield_forecast')">
              <i></i>
              <p>{{ item.date + '原油产量预测值' }}</p>
<!--              <span class="fr">{{ item.originalDate }}</span>-->
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="yieldFlag === 'issue_petroleum_yield'">
            <div class="classification-content-div"
                 v-for="(item, index) in yieldTwoList" :key="index"
                 @click="goDetail('/petroleum/yield', item.completeOriginalDate, 'issue_petroleum_yield')">
              <i></i>
              <p>{{ item.date + '原油产量实际值' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'原油进出口量'" :flag="true" :unit="false"
                                :url="'/petroleum/twoPage/exit'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in exitList" :key="index"
                 @click="goDetail('/petroleum/exit', item.completeOriginalDate, 'issue_petroleum_exit')">
              <i></i>
              <p>{{ item.date + '原油进出口量' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'炼油厂开工率'" :flag="false" :unit="false"
                                :params="{title:'炼油厂开工率',typeList:['国外', '国内']}"
                                :url="'/petroleum/twoPage/rate'"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="rateFlag = 'issue_petroleum_rate'"
                style="width:186px;font-size: 14px"
                @click="toTwoPage('/petroleum/twoPage/rate', 'issue_petroleum_rate')"
                :class="{'stockFlag':rateFlag === 'issue_petroleum_rate'}">国外</span>
          <span class="classification-tabs-three" @mouseover="rateFlag = 'issue_petroleum_rate_china'"
                style="width:186px;font-size: 14px"
                @click="toTwoPage('/petroleum/twoPage/rate', 'issue_petroleum_rate_china')"
                :class="{'stockFlag':rateFlag === 'issue_petroleum_rate_china'}">国内</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="rateFlag === 'issue_petroleum_rate'">
            <div class="classification-content-div"
                 v-for="(item, index) in rateOneList" :key="index"
                 @click="goDetail('/petroleum/rate', item.completeOriginalDate, 'issue_petroleum_rate')">
              <i></i>
              <p>{{ item.date + '国外炼油厂开工率' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="rateFlag === 'issue_petroleum_rate_china'">
            <div class="classification-content-div"
                 v-for="(item, index) in rateTwoList" :key="index"
                 @click="goDetail('/petroleum/rate', item.completeOriginalDate, 'issue_petroleum_rate_china')">
              <i></i>
              <p>{{ item.date + '国内炼油厂开工率' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'成品油裂解价差'" :flag="false" :unit="false"
                                :params="{title:'成品油裂解价差',typeList:['美国成品油裂解', '欧洲成品油裂解', '亚洲成品油裂解']}"
                                :url="'/petroleum/twoPage/difference'"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="differenceFlag = 'issue_petroleum_disintegrate_usa'"
                style="width:124px;font-size: 14px"
                @click="toTwoPage('/petroleum/twoPage/difference', 'issue_petroleum_disintegrate_usa')"
                :class="{'stockFlag':differenceFlag === 'issue_petroleum_disintegrate_usa'}">美国成品油裂解</span>
          <span class="classification-tabs-three" @mouseover="differenceFlag = 'issue_petroleum_disintegrate_europe'"
                style="width:124px;font-size: 14px"
                @click="toTwoPage('/petroleum/twoPage/difference', 'issue_petroleum_disintegrate_europe')"
                :class="{'stockFlag':differenceFlag === 'issue_petroleum_disintegrate_europe'}">欧洲成品油裂解</span>
          <span class="classification-tabs-three" @mouseover="differenceFlag = 'issue_petroleum_disintegrate_asia'"
                style="width:124px;font-size: 14px"
                @click="toTwoPage('/petroleum/twoPage/difference', 'issue_petroleum_disintegrate_asia')"
                :class="{'stockFlag':differenceFlag === 'issue_petroleum_disintegrate_asia'}">亚洲成品油裂解</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="differenceFlag === 'issue_petroleum_disintegrate_usa'">
            <div class="classification-content-div"
                 v-for="(item, index) in differenceOneList" :key="index"
                 @click="goDetail('/petroleum/difference', item.completeOriginalDate, 'issue_petroleum_disintegrate_usa')">
              <i></i>
              <p>{{ item.date + '美国成品油裂解价差' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="differenceFlag === 'issue_petroleum_disintegrate_europe'">
            <div class="classification-content-div"
                 v-for="(item, index) in differenceTwoList" :key="index"
                 @click="goDetail('/petroleum/difference', item.completeOriginalDate, 'issue_petroleum_disintegrate_europe')">
              <i></i>
              <p>{{ item.date + '欧洲成品油裂解价差' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="differenceFlag === 'issue_petroleum_disintegrate_asia'">
            <div class="classification-content-div"
                 v-for="(item, index) in differenceThreeList" :key="index"
                 @click="goDetail('/petroleum/difference', item.completeOriginalDate, 'issue_petroleum_disintegrate_asia')">
              <i></i>
              <p>{{ item.date + '亚洲成品油裂解价差' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'CFTC持仓变化'" :flag="false" :unit="false"
                                :params="{title:'CFTC持仓变化',typeList:['WTI持仓', '布伦特持仓']}"
                                :url="'/petroleum/twoPage/change'"></ClassificationHeader>
          <span class="classification-tabs-three" @mouseover="changeFlag = 'issue_petroleum_wit_position_change'"
                style="width:186px;font-size: 14px"
                @click="toTwoPage('/petroleum/twoPage/change', 'issue_petroleum_wit_position_change')"
                :class="{'stockFlag':changeFlag === 'issue_petroleum_wit_position_change'}">WTI持仓</span>
          <span class="classification-tabs-three" @mouseover="changeFlag = 'issue_petroleum_brent_position_change'"
                style="width:186px;font-size: 14px"
                @click="toTwoPage('/petroleum/twoPage/change', 'issue_petroleum_brent_position_change')"
                :class="{'stockFlag':changeFlag === 'issue_petroleum_brent_position_change'}">布伦特持仓</span>
          <div class="classification-content" style="margin-top: 4px"
               v-if="changeFlag === 'issue_petroleum_wit_position_change'">
            <div class="classification-content-div"
                 v-for="(item, index) in changeOneList" :key="index"
                 @click="goDetail('/petroleum/change', item.completeOriginalDate, 'issue_petroleum_wit_position_change')">
              <i></i>
              <p>{{ item.date + 'WTI持仓变化' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" style="margin-top: 4px"
               v-if="changeFlag === 'issue_petroleum_brent_position_change'">
            <div class="classification-content-div"
                 v-for="(item, index) in changeTwoList" :key="index"
                 @click="goDetail('/petroleum/change', item.completeOriginalDate, 'issue_petroleum_brent_position_change')">
              <i></i>
              <p>{{ item.date + '布伦特持仓变化' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'美元指数'" :flag="true" :unit="false"
                                :url="'/petroleum/twoPage/dollar'"></ClassificationHeader>
          <div class="classification-content" style="margin-top: 4px">
            <div class="classification-content-div" v-for="(item, index) in dollarList" :key="index"
                 @click="goDetail('/petroleum/dollar', item.completeOriginalDate, 'issue_petroleum_dollar_index')">
              <i></i>
              <p>{{ item.date + '美元指数' }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'全球原油供需平衡'" :flag="true" :unit="false" :url="'/petroleum/twoPage/balance'" :neibu="true"
                                :params="{title:'全球原油供需平衡'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in balanceList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="downloadBalance(item)">{{ item.fileTitle }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader :name="'技术及标准'" :flag="true" :unit="false" :url="'/petroleum/twoPage/standard'" :neibu="true"
                                :params="{title:'技术及标准'}"></ClassificationHeader>
          <div class="classification-content">
            <div class="classification-content-div" v-for="(item, index) in standardList" :key="index">
              <i></i>
              <p style="width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                 @click="downloadStandard(item)">{{ item.fileTitle }}</p>
              <span class="fr" style="color: #777777;font-size: 12px;">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog custom-class="previewDialog" :destroy-on-close="true" :close-on-click-modal="false" width="982px"
               :visible.sync="industrialFlag">
      <PetroleumIndustrial @closeIndustrialCh="closeIndustrial" :chainTitle="chainTitle" v-if="industrialFlag" :data1="data1" :data2="data2"
                           :data3="data3" :data4="data4"></PetroleumIndustrial>
    </el-dialog>
  </div>
</template>

<script>
import {
  industryNoAuthList,
  priceNoAuthList,
  stockNoAuthList,
  reportNoAuthList,
  reportDetail,
  exitNoAuthList,
  rateNoAuthList,
  yieldNoAuthList,
  standardDetail,
  industryDetail,
  balanceDetail,
  chainList,
} from '@/api/petroleum'
import ClassificationHeader from '@/components/common/ClassificationHeader'
import Expect from '@/components/common/expect'
import PetroleumIndustrial from '@/components/bigChart/petroleumIndustrial'

export default {
  components: {
    ClassificationHeader,
    PetroleumIndustrial,
    Expect,
  },
  data() {
    return {
      industrialFlag: false,
      // 行业动态
      industryList: [],
      // 研究报告
      reportList: [],
      reportListWeek: [],
      reportListMonth: [],
      reportFlag: 2,
      // 价格指数
      priceFlag: 'issue_petroleum_database_present_price',
      priceOneList: [],
      priceTwoList: [],
      // 库存
      stockFlag: 'issue_petroleum_primary_stock',
      stockOneList: [],
      stockTwoList: [],
      stockThreeList: [],
      stockFourList: [],
      // 产量
      yieldFlag:'issue_petroleum_yield_forecast',
      yieldOneList: [],
      yieldTwoList: [],
      // 进出口
      exitList: [],
      // 炼油厂开工率
      rateFlag:'issue_petroleum_rate',
      rateOneList: [],
      rateTwoList: [],
      // 持仓
      changeFlag: 'issue_petroleum_wit_position_change',
      changeOneList: [],
      changeTwoList: [],
      // 美元指数
      dollarList: [],
      // 供需平衡
      balanceList: [],
      // 价差
      differenceFlag: 'issue_petroleum_disintegrate_usa',
      differenceOneList: [],
      differenceTwoList: [],
      differenceThreeList: [],
      // 行业标准
      standardList: [],
      // 产业链
      chainTitle: '',
      data1: {},
      data2: {},
      data3: {},
      data4: {},
    }
  },
  created() {
    this.getHomeList()
  },
  methods: {
    /**
     * 获取首页信息
     */
    getHomeList() {
      // 产业链
      chainList({dictDataType: 'issue_petroleum_chain'}).then(res => {
        this.chainTitle = res.data['data1']['date'];
        this.data1 = res.data['data1'];
        this.data2 = res.data['data2'];
        this.data3 = res.data['data3'];
        this.data4 = res.data['data4'];
      })
      // 行业动态
      industryNoAuthList({pageNum: 1, pageSize: 8, sourceType: 96}).then(res => {
        this.industryList = res.rows;
      })
      // 价格指数
      priceNoAuthList({pageNum: 1, pageSize: 6, dictDataType: 'issue_petroleum_database_present_price'}).then(res => {
        this.priceOneList = res.rows;
      })
      priceNoAuthList({pageNum: 1, pageSize: 6, dictDataType: 'issue_petroleum_database_futures_price'}).then(res => {
        this.priceTwoList = res.rows;
      })
      // 库存
      stockNoAuthList({pageNum: 1, pageSize: 6, dictDataType: 'issue_petroleum_primary_stock'}).then(res => {
        this.stockOneList = res.rows;
      })
      stockNoAuthList({pageNum: 1, pageSize: 6, dictDataType: 'issue_petroleum_eia_stock'}).then(res => {
        this.stockTwoList = res.rows;
      })
      stockNoAuthList({pageNum: 1, pageSize: 6, dictDataType: 'issue_petroleum_database_futures_price'}).then(res => {
        this.stockThreeList = res.rows;
      })
      stockNoAuthList({pageNum: 1, pageSize: 6, dictDataType: 'issue_petroleum_database_futures_price'}).then(res => {
        this.stockFourList = res.rows;
      })
      // 原油产量
      yieldNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_petroleum_yield_forecast'}).then(res => {
        this.yieldOneList = res.rows;
      })
      yieldNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_petroleum_yield'}).then(res => {
        this.yieldTwoList = res.rows;
      })
      // 持仓变化
      priceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_petroleum_wit_position_change'}).then(res => {
        this.changeOneList = res.rows;
      })
      priceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_petroleum_brent_position_change'}).then(res => {
        this.changeTwoList = res.rows;
      })
      // 研究报告
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 10, fileType: 1}).then(res => {
        this.reportList = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 10, fileType: 2}).then(res => {
        this.reportListWeek = res.rows;
      })
      reportNoAuthList({pageNum: 1, pageSize: 6, sourceType: 10, fileType: 3}).then(res => {
        this.reportListMonth = res.rows;
      })
      // 进出口
      exitNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_petroleum_exit'}).then(res => {
        this.exitList = res.rows;
      })
      // 炼油厂开工率
      rateNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_petroleum_rate'}).then(res => {
        this.rateOneList = res.rows;
      })
      rateNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_petroleum_rate_china'}).then(res => {
        this.rateTwoList = res.rows;
      })
      // 美元指数
      priceNoAuthList({pageNum: 1, pageSize: 8, dictDataType: 'issue_petroleum_dollar_index'}).then(res => {
        this.dollarList = res.rows;
      })
      // 全球供需平衡
      reportNoAuthList({pageNum: 1, pageSize: 8, sourceType: 10, fileType: 5}).then(res => {
        this.balanceList = res.rows;
      })
      // 价差
      priceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_petroleum_disintegrate_usa'}).then(res => {
        this.differenceOneList = res.rows;
      })
      priceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_petroleum_disintegrate_europe'}).then(res => {
        this.differenceTwoList = res.rows;
      })
      priceNoAuthList({pageNum: 1, pageSize: 7, dictDataType: 'issue_petroleum_disintegrate_asia'}).then(res => {
        this.differenceThreeList = res.rows;
      })
      // 技术及标准
      reportNoAuthList({pageNum: 1, pageSize: 8, sourceType: 10, fileType: 4}).then(res => {
        this.standardList = res.rows;
      })
    },
    /**
     * 前往行业报告二级
     */
    reportToPage(url, flag) {
      this.$router.push({path: url, query: {flag}})
    },
    /**
     * 打开关闭模态
     */
    changeIndustrial() {
      this.industrialFlag = true;
    },
    closeIndustrial() {
      this.industrialFlag = false;
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      industryDetail(item['id']).then(() => {
        window.openUrl(item.newsContent)
      })
    },
    /**
     * 预览文件
     */
    downloadReport(row) {
      reportDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['石油', '研究报告', '正文'], row['id']);
      })
    },
    downloadStandard(row) {
      standardDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['石油', '技术及标准', '正文'], row['id']);
      })
    },
    downloadBalance(row) {
      balanceDetail(row['id'] + '/1').then((res) => {
        this.$setMenuInfoPath(['石油', '全球原油供需平衡', '正文'], row['id']);
      })
    },
    /**
     * 切换研究报告tabs
     */
    changeReportFlag(flag) {
      this.reportFlag = flag;
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag, num) {
      this.$router.push({path: `${url}`, query: {flag, num}});
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag, other) {
      this.$router.push({path: `${url}`, query: {id, flag, other}})
    },
  },
}
</script>

<style scoped lang="less">

.report-tabs {
  position: absolute;
  top: 3px;
  right: 11px;

  .tabs-i {
    display: inline-block;
    font-style: normal;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }

  .tabs-i:hover {
    color: #D3131A;
    border-bottom: 2px solid #D3131A;
  }
}

.tabs-i-hover {
  color: #D3131A;
  border-bottom: 2px solid #D3131A;
}

.content {
  height: 355px;
  width: 1200px;
  margin: 0 auto;

  .banner-left {
    width: 650px;
    height: 360px;
    display: inline-block;
    background: url("../../assets/home/shiyoubanner.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;
    cursor: pointer;

    img {
      width: 650px;
      height: 360px;
    }

    .banner-title {
      position: absolute;
      color: #B2F0E4;
      top: 20px;
      left: 245px;
      font-size: 12px;
    }

    .data1 {
      font-size: 10px;
      position: absolute;
      text-align: center;
      top: 182px;
      left: 159px;
      width: 113px;
      height: 50px;
    }

    .data2 {
      font-size: 10px;
      position: absolute;
      text-align: center;
      top: 93px;
      left: 391px;
      width: 118px;
      height: 50px;
    }

    .data3 {
      font-size: 10px;
      position: absolute;
      text-align: center;
      top: 152px;
      left: 391px;
      width: 115px;
      height: 50px;
    }

    .data4 {
      font-size: 10px;
      position: absolute;
      text-align: center;
      top: 229px;
      left: 363px;
      width: 178px;
      height: 50px;
    }
  }

  .banner-right {
    width: 510px;
    height: 360px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;

    .title {
      width: 100%;
      border-bottom: 1px solid #ccc;
      height: 36px;
      line-height: 36px;

      .title-write {
        display: inline-block;
        width: 96px;
        height: 36px;
        border-radius: 4px 4px 0px 0px;
        text-align: center;
        line-height: 36px;
        color: #333;
      }

      .title-write-red {
        color: #fff;
        background: #D3131A;
      }

      .title-more {
        cursor: pointer;
        color: #666666;
        font-size: 12px;
      }
    }

    .banner-right-content {
      ul {
        li {
          margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #D3131A;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }
}

.classification {
  width: 1200px;
  margin: 0 auto;
  padding-top: 39px;

  ul {
    li {
      float: left;
      width: 372px;
      margin-right: 42px;
      height: 300px;
      margin-bottom: 43px;
      position: relative;

      img {
        width: 372px;
      }

      .head {
        color: #222222;
        height: 35px;
        font-size: 18px;
        line-height: 30px;
        position: relative;
        border-bottom: 2px solid #ccc;

        .red-title {
          width: 168px;
          height: 36px;
          background: #D3131A;
          border-radius: 4px 4px 0px 0px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }

        i {
          width: 60px;
          height: 2px;
          background: #CCCCCC;
          display: inline-block;
          position: absolute;
          bottom: 0;
        }

        em {
          width: 4px;
          height: 18px;
          background: #D3131A;
          font-style: normal;
          display: inline-block;
          margin-right: 9px;
          vertical-align: middle;
        }

        img {
          vertical-align: middle;
          margin-right: 9px;

        }

        p {
          font-size: 18px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          cursor: pointer;
          height: 20px;
          border-bottom: 1px solid #fff;
        }

        span:hover {
          border-bottom: 1px solid #222;
        }
      }

      .classification-tabs-two {
        width: 93px;
        height: 34px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        border-top: 2px solid #F2F2F2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .priceFlag {
        border-top: 2px solid #D3131A;
        background: #fff;
        color: #D3131A;
      }

      .classification-tabs-two:hover {
        border-top: 2px solid #D3131A;
        background: #fff;
        color: #D3131A;
      }

      .classification-tabs-three {
        width: 93px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #F2F2F2;
        font-size: 12px;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .stockFlag {
        border-top: 2px solid #D3131A;
        background: #D3131A;
        color: #fff;
      }

      .classification-tabs-three:hover {
        background-color: #D3131A;
        color: #fff;
      }

      .classification-content {
        .classification-content-div {
          height: 33px;
          line-height: 33px;

          i {
            width: 4px;
            height: 4px;
            background: #9B857B;
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
          }

          p {
            width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {

            color: #D3131A;
            text-decoration: underline;
            //border-bottom: 1px solid #D3131A;
          }

          span {
            color: #777777;
            font-size: 12px;
          }

        }

        .price {
          height: 33px;
          line-height: 33px;
          padding: 0 10px;

          img {
            margin-right: 5px;
            width: 8px;
          }
        }

        .price:nth-child(2n+0) {
          background: #F2F2F2;
        }
      }

      .research {
        width: 360px;
        height: 262px;
        border-radius: 0px 0px 4px 4px;
        border: 6px solid #DDDDDD;

        .classification-content-div {
          border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
          height: 35px;
          line-height: 35px;
          margin-top: -1px;

          i {
            margin-left: 5px;
          }

          span {
            margin-right: 5px;
          }
        }

        .classification-content-div:last-child {
          border-bottom: none;
        }
      }
    }

    li:nth-child(3n+0) {
      margin-right: 0;
    }
  }
}

.exitClass {
  .classification-content-div {
    margin-top: 8px;
  }

  p {
    max-width: 200px;
    display: inline-block;
    cursor: pointer;
    // 透明border
    border-style: solid;
    border-width: 1px;
    border-color: transparent;
  }

  p:hover {
    color: #D3131A;
    //border-bottom: 1px solid #D3131A;
    text-decoration: underline;
  }
}

.bulletinWai {
  overflow: auto;
  height: 211px;
  border-bottom: 1px solid #ccc;
}

.bulletin {
  padding: 12px;

  .top {
    img {
      width: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }

    span {
      margin-left: 6px;
      color: #777;
    }

    em {
      color: #777;
      float: right;
      font-style: normal;
    }
  }

  .text {
    padding-left: 28px;
  }
}

.redColor {
  color: #FF6969;
}

.greenColor {
  color: #43E97B;
}
</style>
